'use client';

import { EXERCISES } from '@/lib/exercises';

interface Props {
  value: string;
  onChange: (id: string) => void;
  disabled?: boolean;
}

export function ExerciseSelector({ value, onChange, disabled }: Props) {
  return (
    <div className="flex flex-col gap-2.5">
      <div>
        <p className="mx-label">训练动作</p>
        <p className="text-xs text-[var(--mx-text-muted)] mt-1">选择后 AI 将按对应规则分析</p>
      </div>
      <div className="flex flex-col gap-1.5">
        {EXERCISES.map((ex) => {
          const active = value === ex.id;
          return (
            <button
              key={ex.id}
              type="button"
              disabled={disabled}
              onClick={() => onChange(ex.id)}
              className={`w-full text-left rounded-xl px-3.5 py-2.5 border transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
                active
                  ? 'border-[var(--mx-accent-border)] bg-[var(--mx-accent-soft)]'
                  : 'border-[var(--mx-border)] bg-[var(--mx-bg-elevated)] hover:border-[var(--mx-border)] hover:bg-[var(--mx-surface)]'
              }`}
            >
              <div className="flex items-center justify-between gap-2">
                <span className={`text-sm font-medium ${active ? 'text-[var(--mx-accent)]' : 'text-[var(--mx-text)]'}`}>
                  {ex.label}
                </span>
                {active && (
                  <span className="w-1.5 h-1.5 rounded-full bg-[var(--mx-accent)] shrink-0" />
                )}
              </div>
              <p className="text-[10px] text-[var(--mx-text-muted)] mt-0.5">{ex.hint}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
